import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export function useMembers() {
  const [members, setMembers] = useState([]);
  useEffect(() => { api.get("/org/members").then((r) => setMembers(r.data.filter((m) => m.status === "active"))).catch(() => {}); }, []);
  return members;
}

export function OwnerSelect({ value, onChange, members, placeholder = "Select owner", salesOnly = true, allowNone = false, testId }) {
  const list = salesOnly ? members.filter((m) => m.is_sales_eligible) : members;
  return (
    <Select value={value || (allowNone ? "__none" : undefined)} onValueChange={(v) => onChange(v === "__none" ? null : v)}>
      <SelectTrigger data-testid={testId}><SelectValue placeholder={placeholder} /></SelectTrigger>
      <SelectContent>
        {allowNone && <SelectItem value="__none">Auto-assign (routing rules)</SelectItem>}
        {list.map((m) => <SelectItem key={m.user_id} value={m.user_id}>{m.name || m.email} <span className="meta">· {m.role.replace("_", " ")}</span></SelectItem>)}
      </SelectContent>
    </Select>
  );
}
